var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive",
    transform: "translate(-618 -93.958)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 18,
    height: 18,
    transform: "translate(618 93.958)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "archive-2",
    "data-name": "archive",
    transform: "translate(618.75 96.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M16.5,8v9.75H3V8",
    transform: "translate(-1.5 -4.25)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_337",
    "data-name": "Ret\\xE2ngulo 337",
    width: 16.5,
    height: 3.75,
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_82",
    "data-name": "Linha 82",
    x2: 3,
    transform: "translate(6.75 6.75)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.e0dd80c8a592619bbc5f3e3bd7de2a64.svg";
export { ForwardRef as ReactComponent };